const SLIDES_CONFIG: Record<string, number> = {
	"25": 1,
	"25_md": 1,
	"50": 2,
	"50_md": 2,
	"75": 4,
	"75_md": 3,
};

export const getVisibleSlidesLength = (
	width: string,
	fallback: number,
	deviceType?:string,
): number => deviceType ? SLIDES_CONFIG[`${width}_${deviceType}`]
					: SLIDES_CONFIG[width] 
					?? fallback; 